import React, {useEffect, useState} from 'react';
import {NoSsr, MenuItem, IconButton, InputAdornment, CircularProgress, Backdrop, Hidden} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import ColAtm from "../../../atomic/Col/Col";
import Divider from "@material-ui/core/Divider";
import moment from "moment";
import axios from "axios";
import { getAppLang, getProperty } from "../../../../utils";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { BOOKING_ENGINE_REPORT } from "../../../../constants/api.constants";
import {PageTitle} from "../../../atomic/PageHeader/PageTitle";
import {Animated} from "react-animated-css";
import {BOOKING_ENGINE} from "../../../../constants/appUrls.constants";
import PageHeaderAtm from "../../../atomic/PageHeader/PageHeader";
import Container from "@material-ui/core/Container";
import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import {SelectValidator, TextValidator, ValidatorForm} from 'react-material-ui-form-validator';
import {useForm} from "react-hook-form";
import {MuiPickersUtilsProvider, DatePicker} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import deLocale from "date-fns/locale/de";
import trLocale from "date-fns/locale/tr";
import {makeStyles} from "@material-ui/core/styles";
import { USER_MENU } from '../../../../constants/api.constants';
import { DateRangePicker } from 'react-dates';
import ButtonAtm from '../../../atomic/Button/Button';

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#d71f26',
    },
}))

export default function DailyReports() {
    
    let sumGtr = 0;
    let sumSearch = 0;
    let sumRoomFound = 0;
    let sumRoomNotFound = 0;
    let sumBooking = 0;
    let sumPreBooking = 0;
    let sumBookingCodes = 0;

    let fromRange = '29/03/2020';
    const {t} = useTranslation();
    const classes = useStyles();
    const dispatch = useDispatch();
    const { handleSubmit } = useForm();
    const localeMap = {
        es: esLocale,
        de: deLocale,
        tr: trLocale
    };

    const [report, setReport] = useState([]);
    const [types, setTypes] = useState('TRS');
    const [submitTypes, setSubmitTypes] = useState('TRS');
    const [startDate, setStartDate] = useState(moment());
    const [endDate, setEndDate] = useState(moment());
    const [loadingSpinner, setLoadingSpinner] = useState(false);
    const [hotelName, setHotelName] = useState('');
    const [focusedInput, setFocusedInput] = useState(null);

    useEffect(() => {
        // fetchReport(types);
        fetchTitle();
    },[]);

    const fetchReport = (type_value, start_date, end_date) => {
        setLoadingSpinner(true);
        setReport({});

        const params = {
            params: {
                property_id: getProperty(),
                channel_id : 1,
                start_date : start_date === undefined ? moment().subtract(7, 'days').format('YYYY-MM-DD') : start_date, //default : bugünden 1 hafta önce
                finish_date : end_date === undefined ? moment().format('YYYY-MM-DD') : end_date, // default: bugün
                type : type_value !== null ? type_value : 'TRS' //default: 'TRS'
            }
        }

        axios.post(BOOKING_ENGINE_REPORT, params, {
            headers: {
                "Accept": "application/json",
                authToken: localStorage.getItem('auth'),
                "Content-Type": "application/json",
                "language": getAppLang(),
            }
        }).then((result) => {
            setReport(result.data.data)
            setLoadingSpinner(false)
        }).catch(function (error) {
            console.log(error);
            setLoadingSpinner(false);
        });

    }

    const fetchTitle = () => {
        const params = {
            params: {
                property_id: getProperty(),
            }
        }
        axios.post(USER_MENU, params, {
            headers: {
                "Accept": "application/json",
                authToken: localStorage.getItem('auth'),
                "Content-Type": "application/json",
                "language": getAppLang(),
            }
        }).then((result) => {
            setHotelName(result.data.data.property_list[0].name + " - ");
        }).catch(function (error) {
            console.log(error);
        });
    }

    const handleChangeType = ({target}) => {
        setSubmitTypes(target.value)
        // fetchReport(target.value, startDate, endDate);
    }

    const onSubmit = (e) => {
        setTypes(submitTypes)
        fetchReport(submitTypes, moment(startDate).format("YYYY-MM-DD"), moment(endDate).format("YYYY-MM-DD"));
    };

    const enterStartDate = (date, id, e) => {
        setStartDate(date)
        // fetchReport(types, moment(date).format("YYYY-MM-DD"));
    }
    const enterEndDate = (date, id, e) => {
        setEndDate(date)
        // fetchReport(types, startDate ,moment(date).format("YYYY-MM-DD"));
    }

    const isOutsideRange = (day => {
        let dayIsBlocked = false;
        if(day > moment(fromRange)) {
            dayIsBlocked = true;
        }
        return dayIsBlocked;
    })

        return (
                <NoSsr>
                <PageTitle title={ t('enw-daily_reports-title') } />
                <PageHeaderAtm exitText={ t('btn-dashboard') } backButton={BOOKING_ENGINE} text={ hotelName + t('enw-daily_reports-title')} />
                <Animated animationIn="bounceInRight" animationInDuration={1000} isVisible={true}>
                    <Container maxWidth="xl">
                        <div className="container-width pb-0">
                            <ColAtm className="offer-info-block m-w-auto detail-xs-8 mb-32 daily-filter-box">
                                <Grid container className="details-title detail-title-mob" style={{width:"auto"}}>
                                    <h2 style={{marginTop:"35px", marginLeft:"0px",paddingLeft:"10px"}}>{ t('enw-table-toolbar-filters') }</h2>
                                </Grid>
                                <Grid item spacing={3} xs={12} className="mt-10 mb-16">
                                    <Divider />
                                </Grid>
                                <Grid container spacing={2} xs={12}>
                                    <ValidatorForm className='d-flex-block w-100' onSubmit={handleSubmit(onSubmit)}>
                                        <Grid item xs={4} className='ml-5-rem-report m-w-100-m'>
                                            <SelectValidator
                                                name="addon_type"
                                                className="form-control w-100-m"
                                                variant="outlined"
                                                fullWidth
                                                style={{width:"263px"}}
                                                label={ t('enw-daily_reports-query_type') }
                                                value={submitTypes}
                                                onChange={handleChangeType}
                                            >
                                                <MenuItem value={'TRS'}>{ t('enw-daily_reports-transaction_report') }</MenuItem>
                                                <MenuItem value={'GTR'}>{ t('enw-daily_reports-total_guest_query_report') }</MenuItem>
                                                <MenuItem value={'DSR'}>{ t('enw-daily_reports-date_search_report') }</MenuItem>
                                                <MenuItem value={'UCR'}>{ t('enw-daily_reports-user_country_reports') }</MenuItem>
                                                <MenuItem value={'ULR'}>{ t('enw-daily_reports-user_lang_reports') }</MenuItem>
                                                <MenuItem value={'DSS'}>{ t('enw-daily_reports-date_search_stay_report') }</MenuItem>
                                            </SelectValidator>
                                        </Grid>
                                        <Grid item xs={6} className='m-w-100-m mt-18'>
                                            <Hidden smUp>
                                                <DateRangePicker
                                                    startDate={startDate}
                                                    endDate={endDate}
                                                    startDatePlaceholderText={moment().format('DD.MM.YYYY')}
                                                    endDatePlaceholderText={moment().format('DD.MM.YYYY')}
                                                    onDatesChange={({ startDate, endDate }) => {
                                                        enterStartDate(startDate);
                                                        enterEndDate(endDate);
                                                    }}
                                                    focusedInput={focusedInput}
                                                    onFocusChange={setFocusedInput}
                                                    isOutsideRange={isOutsideRange}
                                                    initialVisibleMonth={() => moment().subtract(1, "month")}
                                                    orientation={"horizontal"}
                                                    // disabled={dateType === ""}
                                                    numberOfMonths={1}
                                                    minimumNights={0}
                                                    displayFormat={"DD.MM.YYYY"}
                                                    // required
                                                    readOnly
                                                    // minDate={moment().subtract(180, 'days')}
                                                    maxDate={moment(startDate).add(179, 'days')}
                                                />
                                            </Hidden>
                                            <Hidden xsDown>
                                                <DateRangePicker
                                                    startDate={startDate}
                                                    endDate={endDate}
                                                    startDatePlaceholderText={moment().format('DD.MM.YYYY')}
                                                    endDatePlaceholderText={moment().format('DD.MM.YYYY')}
                                                    onDatesChange={({ startDate, endDate }) => {
                                                        enterStartDate(startDate);
                                                        enterEndDate(endDate);
                                                    }}
                                                    focusedInput={focusedInput}
                                                    onFocusChange={setFocusedInput}
                                                    isOutsideRange={isOutsideRange}
                                                    initialVisibleMonth={() => moment().subtract(1, "month")}
                                                    orientation={"horizontal"}
                                                    // disabled={dateType === ""}
                                                    // numberOfMonths={2}
                                                    minimumNights={0}
                                                    displayFormat={"DD.MM.YYYY"}
                                                    // required
                                                    readOnly
                                                    // minDate={moment().subtract(180, 'days')}
                                                    maxDate={moment(startDate).add(179, 'days')}
                                                />
                                            </Hidden>
                                        </Grid>
                                        <Grid xs={4} className='mlt-2-rem-report report-btn'>
                                            <ButtonAtm
                                                className="m-auto room-rate-modal-save bg-red"
                                                type="submit"
                                                buttontext={ t('enw-table-toolbar-filters') }
                                                color="primary"
                                                id="submitFilters"
                                                title={startDate && endDate !== null ? '' : t('enw-input-start_and_end_date-warn')}
                                                disabled={startDate && endDate !== null ? false : true}
                                            />
                                    </Grid>
                                    </ValidatorForm>
                                </Grid>
                                      
                            </ColAtm>
                        <ColAtm className="booking-list">
                        
                    {   types === 'TRS' &&
                    
                            <ColAtm className="offer-info-block m-w-auto detail-xs-8 mb-32 pl-r-10" style={{paddingLeft:"20px"}}>
                                {
                                    loadingSpinner &&
                                        <CircularProgress className='circularProgress-report' style={{color:"#d71f26", zIndex: "99"}} />
                                }
                        <Grid container className="details-title detail-title-mob" style={{width:"auto"}}>
                            <h2 className='mt-35-m' style={{marginTop:"0px", marginLeft:"0px",paddingLeft:"10px"}}>{ t('enw-daily_reports-transaction_report') }</h2>
                        </Grid>
                        <Grid item spacing={3} xs={12} className="mt-10 mb-16">
                            <Divider />
                        </Grid>
                        <Grid item container xs={12} className="reservation-info-block">

                            <TableContainer className='m-h-100-table' style={{maxHeight: "500px"}}>
                                <Table stickyHeader sx={{ minWidth: 650 }} aria-label="simple table" id="report-table" style={{border: "0px solid"}}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className='d-none-table'>{ t('enw-daily_reports-transaction-title') }</TableCell>
                                            <TableCell className='d-none-table' align="right">{ t('enw-chart-channel_count') }</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow key={"1"} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell align="right" className='d-none d-block-table fw-800' data-label={ t('enw-daily_reports-transaction-title') }>{ t('enw-chart-channel_count') }</TableCell>
                                            <TableCell className='d-none-table' component="th" scope="row">
                                            { t('enw-daily_reports-room_found') }
                                            </TableCell>
                                            <TableCell data-label={ t('enw-daily_reports-room_found') } align="right">
                                                {report?.roomFound === undefined || report?.roomFound === null ? '-' : report?.roomFound}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow key={"2"} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell className='d-none-table' component="th" scope="row">
                                            { t('enw-daily_reports-room_not_found') }
                                            </TableCell>
                                            <TableCell data-label={ t('enw-daily_reports-room_not_found') } align="right">
                                                {report?.roomNotFound === undefined || report?.roomNotFound === null ? '-' : report?.roomNotFound}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow key={"3"} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell className='d-none-table' component="th" scope="row">
                                            { t('enw-reservation-prebooking') }
                                            </TableCell>
                                            <TableCell data-label={ t('enw-reservation-prebooking') } align="right">
                                                {report?.preBooking === undefined || report?.preBooking === null ? '-' : report?.preBooking}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow key={"4"} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell className='d-none-table' component="th" scope="row">
                                            { t('btn-booking') }
                                            </TableCell>
                                            <TableCell data-label={ t('btn-booking') } align="right">
                                                {report?.booking === undefined || report?.booking === null ? '-' : report?.booking}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow key={"5"} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row" className='fw-800 d-none-table'>
                                            { t('enw-daily_reports-total_search') }
                                            </TableCell>
                                            <TableCell data-label= { t('enw-daily_reports-total_search') } align="right" className='fw-800'>
                                                {report?.search === undefined || report?.search === null ? '-' : report?.search}
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </ColAtm>
                    
                }
                {   types === 'GTR' &&
                        <Grid item xs={12}>
                            <ColAtm className="offer-info-block m-w-auto mb-32 detail-xs-8 pl-r-10" style={{paddingLeft:"20px"}}>
                                {
                                    loadingSpinner &&
                                        <CircularProgress className='circularProgress-report' style={{color:"#d71f26", zIndex: "99"}} />
                                }
                                <Grid container className="details-title detail-title-mob">
                                    <h2 className='mt-35-m' style={{marginTop:"0px", marginLeft:"0px",paddingLeft:"10px"}}>{ t('enw-daily_reports-total_guest_query_report') }</h2>
                                </Grid>
                                <Grid item spacing={3} xs={12} className="mt-10 mb-16">
                                    <Divider />
                                </Grid>
                                <Grid item container xs={12} className="reservation-info-block">
                                    <Grid container xs={12} lg={12} className="mb-12">
                                    {
                                        report?.length === 0 ?
                                        <Grid container
                                            direction="column"
                                            justify="center"
                                            alignItems="center">
                                            <h2>  { t('enw-notification-no_results') } </h2>
                                        </Grid> 
                                        :
                                        <TableContainer className='m-h-100-table' style={{maxHeight: "500px"}}>
                                            <Table stickyHeader sx={{ minWidth: 650 }} aria-label="simple table" id="report-table" style={{border: "0px solid"}}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell className='d-none-table'>{ t('enw-daily_reports-query_type') }</TableCell>
                                                        <TableCell className='d-none-table' align="right">{ t('enw-chart-channel_count') }</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                 { Object.entries(report).map((gtr, index) => (
                                                    <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                        <TableCell align="right" className='d-none d-block-table fw-800' data-label={ t('enw-daily_reports-transaction-title') }>{ t('enw-chart-channel_count') }</TableCell>
                                                        <TableCell className='d-none-table' component="th" scope="row">
                                                            {gtr[1].text}
                                                        </TableCell>
                                                        <TableCell data-label={gtr[1].text} align="right">
                                                        {gtr[1].count}
                                                        </TableCell>
                                                        <div className='d-none'>{sumGtr += gtr[1].count}</div>
                                                    </TableRow>
                                                 ))}
                                                 <TableRow key={"1"} style={{position: "sticky", bottom:"0px", backgroundColor: "#fafafa"}} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                    <TableCell className='d-none-table fw-800' component="th" scope="row">
                                                        { t('enw-offer-dashboard-total') }
                                                    </TableCell>
                                                    <TableCell data-label={ t('enw-offer-dashboard-total') } align="right" className='fw-800'>
                                                        {sumGtr}
                                                    </TableCell>
                                                </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    }
                                    </Grid>
                                </Grid>
                            </ColAtm>
                        </Grid>
                    
                        }
                    {   types === 'DSR' &&
                        <Grid item xs={12}>
                            <ColAtm className="offer-info-block m-w-auto detail-xs-8 mb-32 pl-r-10" style={{paddingLeft:"20px"}}>
                                {
                                    loadingSpinner &&
                                        <CircularProgress className='circularProgress-report' style={{color:"#d71f26", zIndex: "99"}} />
                                }
                                <Grid container className="details-title detail-title-mob">
                                    <h2 className='mt-35-m' style={{marginTop:"0px", marginLeft:"0px",paddingLeft:"10px"}}>{ t('enw-daily_reports-date_search_report') }</h2>
                                </Grid>
                                <Grid item spacing={3} xs={12} className="mt-10 mb-16">
                                    <Divider />
                                </Grid>
                                <Grid item container xs={12} className="reservation-info-block">
                                    <Grid container xs={12} lg={12} className="mb-12">
                                    {
                                        report?.length === 0 ?
                                        <Grid container
                                            direction="column"
                                            justify="center"
                                            alignItems="center">
                                            <h2>  { t('enw-notification-no_results') } </h2>
                                        </Grid> 
                                        :
                                        <TableContainer className='m-h-100-table' style={{maxHeight: "500px"}}>
                                            <Table stickyHeader sx={{ minWidth: 650 }} aria-label="simple table" id="report-table" style={{border: "0px solid"}}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell className='d-none-table'>{ t('enw-input-date') }</TableCell>
                                                        <TableCell className='d-none-table' align="right">{ t('enw-daily_reports-query_number') }</TableCell>
                                                        <TableCell className='d-none-table' align="right">{ t('enw-daily_reports-room_found') }</TableCell>
                                                        <TableCell className='d-none-table' align="right">{ t('enw-daily_reports-room_not_found') }</TableCell>
                                                        <TableCell className='d-none-table' align="right">{ t('btn-booking') }</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                 { Object.entries(report).map((dsr,index) => (
                                                    <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                        <TableCell className='fw-800-m' data-label={ t('enw-input-date') } scope="row">
                                                            {dsr[1].text}
                                                        </TableCell>
                                                        <TableCell data-label={ t('enw-daily_reports-query_number') } align="right">
                                                            {dsr[1].search}
                                                            <div className='d-none'>{sumSearch += dsr[1].search}</div>
                                                        </TableCell>
                                                        <TableCell data-label={ t('enw-daily_reports-room_found') } align="right">
                                                            {dsr[1].roomFound}
                                                            <div className='d-none'>{sumRoomFound += dsr[1].roomFound}</div>
                                                        </TableCell>
                                                        <TableCell data-label={ t('enw-daily_reports-room_not_found') } align="right">
                                                        {dsr[1].roomNotFound}
                                                        <div className='d-none'>{sumRoomNotFound += dsr[1].roomNotFound}</div>
                                                        </TableCell>
                                                        <TableCell data-label={ t('btn-booking') } align="right">
                                                        {dsr[1].booking}
                                                        <div className='d-none'>{sumBooking += dsr[1].booking}</div>
                                                        </TableCell>
                                                        
                                                    </TableRow>
                                                 ))}
                                                <TableRow key={"1"} style={{position: "sticky", bottom:"0px", backgroundColor: "#fafafa"}} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                    <TableCell className='d-none-table fw-800' component="th" scope="row">
                                                        { t('enw-offer-dashboard-total') }
                                                    </TableCell>
                                                    <TableCell data-label= { t('enw-offer-dashboard-total') + " " + t('enw-daily_reports-query_number') } align="right" className='fw-800'>
                                                        {sumSearch}
                                                    </TableCell>
                                                    <TableCell data-label={ t('enw-offer-dashboard-total') + " " + t('enw-daily_reports-room_found') } align="right" className='fw-800'>
                                                        {sumRoomFound}
                                                    </TableCell>
                                                    <TableCell data-label={ t('enw-offer-dashboard-total') + " " +t('enw-daily_reports-room_not_found')  } align="right" className='fw-800'>
                                                        {sumRoomNotFound}
                                                    </TableCell>
                                                    <TableCell data-label={ t('enw-offer-dashboard-total') + " " + t('btn-booking') } align="right" className='fw-800'>
                                                        {sumBooking}
                                                    </TableCell>
                                                </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    }
                                    </Grid>
                                </Grid>
                            </ColAtm>
                        </Grid>
                        }
                    {   types === 'DSS' &&
                        <Grid item xs={12}>
                            <ColAtm className="offer-info-block m-w-auto detail-xs-8 mb-32 pl-r-10" style={{paddingLeft:"20px"}}>
                                {
                                    loadingSpinner &&
                                        <CircularProgress className='circularProgress-report' style={{color:"#d71f26", zIndex: "99"}} />
                                }
                                <Grid container className="details-title detail-title-mob">
                                    <h2 className='mt-35-m' style={{marginTop:"0px", marginLeft:"0px",paddingLeft:"10px"}}>{ t('enw-daily_reports-date_search_report') }</h2>
                                </Grid>
                                <Grid item spacing={3} xs={12} className="mt-10 mb-16">
                                    <Divider />
                                </Grid>
                                <Grid item container xs={12} className="reservation-info-block">
                                    <Grid container xs={12} lg={12} className="mb-12">
                                    {
                                        report?.length === 0 ?
                                        <Grid container
                                            direction="column"
                                            justify="center"
                                            alignItems="center">
                                            <h2>  { t('enw-notification-no_results') } </h2>
                                        </Grid> 
                                        :
                                        <TableContainer className='m-h-100-table' style={{maxHeight: "530px"}}>
                                            <Table stickyHeader sx={{ minWidth: 650 }} aria-label="simple table" id="report-table" style={{border: "0px solid"}}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell className='d-none-table'>{ t('enw-input-date') }</TableCell>
                                                        <TableCell className='d-none-table' align="right">{ t('enw-daily_reports-query_number') }</TableCell>
                                                        <TableCell className='d-none-table' align="right">{ t('enw-daily_reports-room_found') }</TableCell>
                                                        <TableCell className='d-none-table' align="right">{ t('enw-daily_reports-room_not_found') }</TableCell>
                                                        <TableCell className='d-none-table' align="right">{ t('enw-reservation-prebooking') }</TableCell>
                                                        <TableCell className='d-none-table' align="right">{ t('btn-booking') }</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                 { Object.entries(report).map((dss,index) => (
                                                    <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                        <TableCell className='fw-800-m' data-label={ t('enw-input-date') } scope="row">
                                                            {dss[1].text}
                                                        </TableCell>
                                                        <TableCell data-label={ t('enw-daily_reports-query_number') } align="right">
                                                            {dss[1].search}
                                                            <div className='d-none'>{sumSearch += dss[1].search}</div>
                                                        </TableCell>
                                                        <TableCell data-label={ t('enw-daily_reports-room_found') } align="right">
                                                            {dss[1].roomFound}
                                                            <div className='d-none'>{sumRoomFound += dss[1].roomFound}</div>
                                                        </TableCell>
                                                        <TableCell data-label={ t('enw-daily_reports-room_not_found') } align="right">
                                                            {dss[1].roomNotFound}
                                                            <div className='d-none'>{sumRoomNotFound += dss[1].roomNotFound}</div>
                                                        </TableCell>
                                                        <TableCell data-label={ t('enw-reservation-prebooking') } align="right">
                                                            {dss[1].preBooking}
                                                            <div className='d-none'>{sumPreBooking += dss[1].preBooking}</div>
                                                        </TableCell>
                                                        <TableCell data-label={ t('btn-booking') } align="right">
                                                            {dss[1].booking}
                                                            <div className='d-none'>{sumBooking += dss[1].booking}</div>
                                                            <div className='d-none'>{sumBookingCodes += (dss[1].bookingCode?.length || 0)}</div>
                                                        </TableCell>
                                                        
                                                    </TableRow>
                                                 ))}
                                                <TableRow key={"1"} style={{position: "sticky", bottom: "40px", backgroundColor: "#fafafa"}} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                    <TableCell className='d-none-table fw-800' component="th" scope="row">
                                                        { t('enw-offer-dashboard-total') }
                                                    </TableCell>
                                                    <TableCell data-label= { t('enw-offer-dashboard-total') + " " + t('enw-daily_reports-query_number') } align="right" className='fw-800'>
                                                        {sumSearch}
                                                    </TableCell>
                                                    <TableCell data-label={ t('enw-offer-dashboard-total') + " " + t('enw-daily_reports-room_found') } align="right" className='fw-800'>
                                                        {sumRoomFound}
                                                    </TableCell>
                                                    <TableCell data-label={ t('enw-offer-dashboard-total') + " " +t('enw-daily_reports-room_not_found')  } align="right" className='fw-800'>
                                                        {sumRoomNotFound}
                                                    </TableCell>
                                                    <TableCell data-label={ t('enw-offer-dashboard-total') + " " + t('enw-reservation-prebooking') } align="right" className='fw-800'>
                                                        {sumPreBooking}
                                                    </TableCell>
                                                    <TableCell data-label={ t('enw-offer-dashboard-total') + " " + t('btn-booking') } align="right" className='fw-800'>
                                                        {sumBooking}
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key={"2"} style={{position: "sticky", bottom: "0px", backgroundColor: "#f0f0f0"}} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                    <TableCell className='d-none-table fw-800' component="th" scope="row" colSpan={5}>
                                                       {t('enw-channels-reservation_count-title')}
                                                    </TableCell>
                                                    <TableCell data-label={t('enw-channels-reservation_count-title') + " (Booking Code)"} align="right" className='fw-800'>
                                                        {sumBookingCodes}
                                                    </TableCell>
                                                </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    }
                                    </Grid>
                                </Grid>
                            </ColAtm>
                        </Grid>
                        }

                        {   types === 'UCR' &&
                        <Grid item xs={12}>
                            <ColAtm className="offer-info-block m-w-auto detail-xs-8 mb-32 pl-r-10" style={{paddingLeft:"20px"}}>
                                {
                                    loadingSpinner &&
                                        <CircularProgress className='circularProgress-report' style={{color:"#d71f26", zIndex: "99"}} />
                                }
                                <Grid container className="details-title detail-title-mob">
                                    <h2 className='mt-35-m' style={{marginTop:"0px", marginLeft:"0px",paddingLeft:"10px"}}>{ t('enw-daily_reports-user_country_reports') }</h2>
                                </Grid>
                                <Grid item spacing={3} xs={12} className="mt-10 mb-16">
                                    <Divider />
                                </Grid>
                                <Grid item container xs={12} className="reservation-info-block">
                                    <Grid container xs={12} lg={12} className="mb-12">
                                    {
                                        report?.length === 0 ?
                                        <Grid container
                                            direction="column"
                                            justify="center"
                                            alignItems="center">
                                            <h2>  { t('enw-notification-no_results') } </h2>
                                        </Grid> 
                                        :
                                        <TableContainer className='m-h-100-table' style={{maxHeight: "500px"}}>
                                            <Table stickyHeader sx={{ minWidth: 650 }} aria-label="simple table" id="report-table" style={{border: "0px solid"}}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell className='d-none-table'>{ t('enw-input-country') }</TableCell>
                                                        <TableCell className='d-none-table' align="right">{ t('enw-daily_reports-query_number') }</TableCell>
                                                        <TableCell className='d-none-table' align="right">{ t('enw-daily_reports-room_found') }</TableCell>
                                                        <TableCell className='d-none-table' align="right">{ t('enw-daily_reports-room_not_found') }</TableCell>
                                                        <TableCell className='d-none-table' align="right">{ t('btn-booking') }</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                { Object.entries(report).map((ucr, index) => (
                                                    <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                        <TableCell className='fw-800-m' data-label={ t('enw-input-country') } scope="row">
                                                            {ucr[1].text}
                                                        </TableCell>
                                                        <TableCell data-label={ t('enw-daily_reports-query_number') } align="right">
                                                            {ucr[1].search}
                                                            <div className='d-none'>{sumSearch += ucr[1].search}</div>
                                                        </TableCell>
                                                        <TableCell data-label={ t('enw-daily_reports-room_found') } align="right">
                                                            {ucr[1].roomFound}
                                                            <div className='d-none'>{sumRoomFound += ucr[1].roomFound}</div>
                                                        </TableCell>
                                                        <TableCell data-label={ t('enw-daily_reports-room_not_found') } align="right">
                                                            {ucr[1].roomNotFound}
                                                            <div className='d-none'>{sumRoomNotFound += ucr[1].roomNotFound}</div>
                                                        </TableCell>
                                                        <TableCell data-label={ t('btn-booking') } align="right">
                                                            {ucr[1].booking}
                                                            <div className='d-none'>{sumBooking += ucr[1].booking}</div>
                                                        </TableCell>
                                                    </TableRow>
                                                 ))}
                                                 <TableRow key={"1"} style={{position: "sticky", bottom:"0px", backgroundColor: "#fafafa"}} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                    <TableCell className='d-none-table fw-800' component="th" scope="row">
                                                        { t('enw-offer-dashboard-total') }
                                                    </TableCell>
                                                    <TableCell data-label= { t('enw-offer-dashboard-total') + " " + t('enw-daily_reports-query_number') } align="right" className='fw-800'>
                                                        {sumSearch}
                                                    </TableCell>
                                                    <TableCell data-label={ t('enw-offer-dashboard-total') + " " + t('enw-daily_reports-room_found') } align="right" className='fw-800'>
                                                        {sumRoomFound}
                                                    </TableCell>
                                                    <TableCell data-label={ t('enw-offer-dashboard-total') + " " +t('enw-daily_reports-room_not_found')  } align="right" className='fw-800'>
                                                        {sumRoomNotFound}
                                                    </TableCell>
                                                    <TableCell data-label={ t('enw-offer-dashboard-total') + " " + t('btn-booking') } align="right" className='fw-800'>
                                                        {sumBooking}
                                                    </TableCell>
                                                </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    }
                                    </Grid>
                                </Grid>
                            </ColAtm>
                        </Grid>
                        }

                    {   types === 'ULR' &&
                        <Grid item xs={12}>
                            <ColAtm className="offer-info-block m-w-auto detail-xs-8 mb-32 pl-r-10" style={{paddingLeft:"20px"}}>
                                {
                                    loadingSpinner &&
                                        <CircularProgress className='circularProgress-report' style={{color:"#d71f26", zIndex: "99"}} />
                                }
                                <Grid container className="details-title detail-title-mob">
                                    <h2 className='mt-35-m' style={{marginTop:"0px", marginLeft:"0px",paddingLeft:"10px"}}>{ t('enw-daily_reports-user_lang_reports') }</h2>
                                </Grid>
                                <Grid item spacing={3} xs={12} className="mt-10 mb-16">
                                    <Divider />
                                </Grid>
                                <Grid item container xs={12} className="reservation-info-block">
                                    <Grid container xs={12} lg={12} className="mb-12">
                                    {
                                        report?.length === 0 ?
                                        <Grid container
                                            direction="column"
                                            justify="center"
                                            alignItems="center">
                                            <h2>  { t('enw-notification-no_results') } </h2>
                                        </Grid> 
                                        :
                                        <TableContainer className='m-h-100-table' style={{maxHeight: "500px"}}>
                                            <Table stickyHeader sx={{ minWidth: 650 }} aria-label="simple table" id="report-table" style={{border: "0px solid"}}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell className='d-none-table'>{ t('enw-input-language') }</TableCell>
                                                        <TableCell className='d-none-table' align="right">{ t('enw-daily_reports-query_number') }</TableCell>
                                                        <TableCell className='d-none-table' align="right">{ t('enw-daily_reports-room_found') }</TableCell>
                                                        <TableCell className='d-none-table' align="right">{ t('enw-daily_reports-room_not_found') }</TableCell>
                                                        <TableCell className='d-none-table' align="right">{ t('btn-booking') }</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                { Object.entries(report).map((ulr, index) => (
                                                    <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                        <TableCell className='fw-800-m' data-label={ t('enw-input-language') }  scope="row">
                                                            {ulr[1].text}
                                                        </TableCell>
                                                        <TableCell data-label={ t('enw-daily_reports-query_number') } align="right">
                                                            {ulr[1].search}
                                                            <div className='d-none'>{sumSearch += ulr[1].search}</div>
                                                        </TableCell>
                                                        <TableCell data-label={ t('enw-daily_reports-room_found') } align="right">
                                                            {ulr[1].roomFound}
                                                            <div className='d-none'>{sumRoomFound += ulr[1].roomFound}</div>
                                                        </TableCell>
                                                        <TableCell data-label={ t('enw-daily_reports-room_not_found') } align="right">
                                                            {ulr[1].roomNotFound}
                                                            <div className='d-none'>{sumRoomNotFound += ulr[1].roomNotFound}</div>
                                                        </TableCell>
                                                        <TableCell data-label={ t('btn-booking') } align="right">
                                                            {ulr[1].booking}
                                                            <div className='d-none'>{sumBooking += ulr[1].booking}</div>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                                 <TableRow key={"1"} style={{position: "sticky", bottom:"0px", backgroundColor: "#fafafa"}} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                    <TableCell className='d-none-table fw-800' component="th" scope="row">
                                                        { t('enw-offer-dashboard-total') }
                                                    </TableCell>
                                                    <TableCell data-label= { t('enw-offer-dashboard-total') + " " + t('enw-daily_reports-query_number') } align="right" className='fw-800'>
                                                        {sumSearch}
                                                    </TableCell>
                                                    <TableCell data-label={ t('enw-offer-dashboard-total') + " " + t('enw-daily_reports-room_found') } align="right" className='fw-800'>
                                                        {sumRoomFound}
                                                    </TableCell>
                                                    <TableCell data-label={ t('enw-offer-dashboard-total') + " " +t('enw-daily_reports-room_not_found')  } align="right" className='fw-800'>
                                                        {sumRoomNotFound}
                                                    </TableCell>
                                                    <TableCell data-label={ t('enw-offer-dashboard-total') + " " + t('btn-booking') } align="right" className='fw-800'>
                                                        {sumBooking}
                                                    </TableCell>
                                                </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    }
                                    </Grid>
                                </Grid>
                            </ColAtm>
                        </Grid>
                        }
                            </ColAtm>
                        </div>
                    </Container>
                </Animated>
                </NoSsr>
            ) 
    }



